

export default {
  name: "LayoutFooters"
}
